import { useContext } from "react"

import { PageLanguageContext } from "./pageLanguage"

const SiteLanguage = () => useContext(PageLanguageContext)

export default SiteLanguage;
